import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/firestore';
import 'firebase/storage'

import React, { useState, useEffect } from "react";

import { useFirestoreDocData, useFirestoreDocDataOnce, useFirestore, SuspenseWithPerf, useFirestoreCollectionData } from 'reactfire';

export function useContestData (contestID) {

    const [isLoading, setIsLoading] = useState(null);
    const [isError, setIsError] = useState(null);
    const [currentData, setCurrentData] = useState(null);
    const [hasLoaded, setHasLoaded] = useState(false);
    
    const refContest = useFirestore()
    .collection('gamingContest')
    .doc(contestID);

    const dataContest = useFirestoreDocData(refContest);

    useEffect(() => {

        console.log('Data Change', dataContest);

        if(dataContest.status === "loading"){
            setCurrentData(null);
            setHasLoaded(false);
        } else if(dataContest.status === "success"){
            if(dataContest.data){
                setCurrentData(dataContest.data);
            }

            setHasLoaded(true);
        }

    },[dataContest, dataContest.status])

    useEffect(() => {

        if(currentData !== null && currentData !== undefined){
            console.log(`Current Data`, currentData);


        }

    },[currentData])

    return {
        data: currentData,
        hasLoaded: hasLoaded,
    }

}
